import { render, staticRenderFns } from "./AddBasicConfig.vue?vue&type=template&id=2e9f9843&"
import script from "./AddBasicConfig.vue?vue&type=script&lang=js&"
export * from "./AddBasicConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddBasicConfig.vue"
export default component.exports